import React from "react";
import {
  ButtonContainer,
  CancelButton,
  ConfirmButton,
  ContentContainer,
  Message,
  ModalContainer,
  Overlay,
  Title,
} from "../alertModal/alertModal.styled";

interface InfoModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: "warning" | "danger" | "info";
}

export const InfoModal: React.FC<InfoModalProps> = (props) => {
  if (!props.isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      props.onCancel();
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <ModalContainer>
        <ContentContainer>
          <Title>{props.title}</Title>
          <Message>{props.message}</Message>
        </ContentContainer>

        <ButtonContainer>
          {props.cancelText && (
            <CancelButton onClick={props.onCancel}>
              {props.cancelText}
            </CancelButton>
          )}
          <ConfirmButton onClick={props.onConfirm} variant={props.variant ? props.variant : 'info'}>
            {props.confirmText}
          </ConfirmButton>
        </ButtonContainer>
      </ModalContainer>
    </Overlay>
  );
};
